import http from '@utils/http.js'

export const photoSettings = () => {
    const formEl = document.querySelector('.edit-photo-form')

    formEl?.addEventListener('submit', function (e) {
        e.preventDefault()

        const title = formEl.querySelector('input[name="title"]').value
        const hash = formEl.querySelector('input[name="id"]').value

        http.post('/place/photo/edit/', {
            title: title,
            id: hash,
        }).then(({ data }) => {
            if (data.success) {
                window.location.reload()
            }
        })
    })
}
